import React from 'react';

import { fetchInternalDomain, onLocalStudio } from '../../../../pages/creatives/site-host';

/** The site at a host, as a link the browser opens. Pure. */
export const internalSiteHref = (host: string | null): string | null => (host ? `https://${host}` : null);

/**
 * The active brand's deployed site at its INTERNAL host (casino-creation's `internal_domain`, e.g.
 * `belaro-d53f446f.spark-test.newtoncelestial.com`), for a dev-only "open the internal site" link: off production
 * the public domain is usually not connected. Only when this Studio runs on localhost; null anywhere else, while the
 * host is being looked up, and when the brand has none.
 */
export const useLocalInternalSite = (tenantId: number | undefined, publicDomain: string): string | null => {
  const [found, setFound] = React.useState<{ key: string; host: string | null } | null>(null);
  const local = onLocalStudio();
  const key = `${tenantId ?? ''}|${publicDomain}`;

  React.useEffect(() => {
    // Syncs with casino-creation: looks this brand's internal host up, aborting a lookup that a brand switch replaced
    // so its late answer never lands on the next brand.
    if (!local || tenantId === undefined || !publicDomain) return undefined;
    const abort = new AbortController();
    fetchInternalDomain(tenantId, publicDomain, abort.signal)
      .then((host) => {
        if (!abort.signal.aborted) setFound({ key, host });
      })
      .catch(() => {
        if (!abort.signal.aborted) setFound({ key, host: null });
      });
    return () => abort.abort();
  }, [local, tenantId, publicDomain, key]);

  return found?.key === key ? internalSiteHref(found.host) : null;
};
